import React from "react";
import { useContext } from "react";
import { SnackBarContext } from "../Context/SnackBar";

import { makeStyles } from "@material-ui/core/styles";
import { Snackbar, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
const useStyles = makeStyles((theme) => ({
  successDark: {
    color: "#4dff4d",
    boxShadow: "none",
    borderRadius: 0,
    border: "2px solid #4dff4d",
  },
  errorDark: {
    color: "white",
    boxShadow: "none",
    borderRadius: 0,
    border: "2px solid #ff6666",
  },
  infoDark: {
    color: "#66d9ff",
    boxShadow: "none",
    borderRadius: 0,
    border: "2px solid #66d9ff",
  },
  success: {
    backgroundColor: "rgba(71, 107, 107, 0.3)",
    color: "#476b6b",
    boxShadow: "none",
    borderRadius: 0,
  },
  error: {
    backgroundColor: "#092635",
    color: "white",
    boxShadow: "none",
    borderRadius: 0,
    border: "3px solid white",
  },
  warning: {
    backgroundColor: "rgba(255, 219, 153, 0.3)",
    color: "#ffc14d",
    boxShadow: "none",
    borderRadius: 0,
  },
  info: {
    backgroundColor: "rgba(153, 230, 255, 0.3)",
    color: "#66d9ff",
    boxShadow: "none",
    borderRadius: 0,
  },
}));
const CsnackBar = () => {
  const classes = useStyles();
  const { status, handleStatus } = useContext(SnackBarContext);

  const handleClose = (event, reason) => {
    handleStatus({ Open: false });
  };
  return (
    <>
      <Snackbar
        ContentProps={{
          classes: {
            root: classes["error"],
          },
        }}
        autoHideDuration={6000}
        open={status?.status?.Open}
        message={status?.status?.message || "unauthorized"}
        onClose={handleClose}
        action={
          <>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={handleClose}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </>
        }
      />{" "}
    </>
  );
};

export default CsnackBar;
